import { createBrowserHistory } from 'history';
import queryString from 'query-string';
import React, { Component } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { commonConstant } from '../../../common';
import {
  addProductsInstallmentToCart,
  addProductsToCart,
  addProductsToCartPublic,
  createCartInstallment,
  createCartPublic,
  getCart,
  getCartId,
  getCartPublic,
  getPriceFormat,
  getPromotionById,
  getPublicPromotionById,
  INSTALLMENT_TYPE,
  isCartABOMemberType,
  isCartABOType,
  message,
  PAYMENT_OPTION,
  PAYMENT_TYPE,
  STOCK_STATUS,
} from '../../../services/promotion/utils.service';
import Liff from '../../modal/Liff';
import '../../promotion/CartPromotion.scss';
import CartIcon from '../CartIcon';
import PaymentOption from '../PaymentOption';
import BundleProductItem from '../PromotionTemplate/BundleProductItem';
import Product from '../PromotionTemplate/Product';
import { ProductItemType } from '../PromotionTemplate/Product';
import { liffGetProfile } from '../../../services/promotion/auth.service';
import { getCartData, updateCartData } from '../../../actions/cartAction';
import { connect } from 'react-redux';
import { getParamsString } from '../../../utill.func';
import { SESSION_KEY, VIEW_MORE_DETAILS } from '../../../common/commonConstant';
import CustomSweetAlert from '../../../common/customSweetAlert/CustomSweetAlert';

export const history = createBrowserHistory();

export const ABO_MEMBER = 'ABO';
export const FOA_MEMBER = 'RETAIL';

export const UpdateState = {
  FINISH: 'FINISH',
  CHANGE: 'CHANGE',
  CLEAR: 'CLEAR',
  INIT: 'INIT',
};

const { liff } = window;

export class PromotionProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: null,
      isFOAEmpty: '',
      entries: 0,
      accountType: '',
      totalPrice: 0,
      totalPointValue: 0,
      totalBusinessVolume: 0,
      loading: true,
      promotionData: [],
      totalSelected: 0,
      isLiffopen: false,
      paymentOptions: [],
      relatedProducts: [],
      productSelected: [],
      paymentOptionSelected: null,
    };

    this.onOpenLiff = this.onOpenLiff.bind(this);
    this.onCloseLiff = this.onCloseLiff.bind(this);
    this.setTotalprice = this.setTotalprice.bind(this);
    this.setTotalSelected = this.setTotalSelected.bind(this);
    this.handleFullPayment = this.handleFullPayment.bind(this);
    this.setProductSelected = this.setProductSelected.bind(this);
    this.handleProductToCart = this.handleProductToCart.bind(this);
    this.handlePayByInstallment = this.handlePayByInstallment.bind(this);
    this.setPaymentOptionSelected = this.setPaymentOptionSelected.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleProductDetailsClick = this.handleProductDetailsClick.bind(this);
  }

  async componentDidMount() {
    await this.fetchData();
  }

  async fetchData() {
    const urlParams = queryString.parse(this.props.location.search);
    const promotionId = urlParams.id;
    const addQty = +urlParams.addQty;

    if (!promotionId) {
      return CustomSweetAlert({
        title: "",
        text: "ไม่พบข้อมูลโปรโมชั่น",
        confirmButtonText: "ตกลง",
      });
    }

    const customerFOA = JSON.parse(sessionStorage.getItem('customerFOAData'));
    const guid = sessionStorage.getItem('guid');
    if (!customerFOA) {
      this.setState({ isFOAEmpty: true });
    }
    const cart = !customerFOA
      ? (this.props?.data.length > 0 ? this.props.data : await this.props.getCartData('FULL', getCartId(urlParams.isInstallment)))
      : guid
        ? await getCartPublic(guid)
        : await createCartPublic();
    if (Array.isArray(cart)) {
      const promotionData = !customerFOA
        ? await getPromotionById(promotionId)
        : await getPublicPromotionById(promotionId);
      const relatedProducts = await this.setQuantityToProduct(
        promotionData.relatedProducts, addQty
      );
      this.setState({
        cart,
        promotionData,
        relatedProducts,
        loading: false,
      });
    } else {
      console.log('CART : ', cart);
      CustomSweetAlert({
        title: "",
        text: "ไม่พบข้อมูลตระกร้า กรุณาลองใหม่ภายหลัง",
        confirmButtonText: "ตกลง",
      });
    }
    this.setAccountType(cart?.length ? cart[0].account.accountType : '');
    let totalEntries = 0;
    let entries = cart?.length && cart[0].entries.map((values) => {
      return values.quantity;
    });
    entries && entries.forEach((element) => {
      totalEntries += element;
    });
    this.setCartEntries(totalEntries);
  }

  onCloseLiff() {
    this.setState({ isLiffopen: false });
  }

  onOpenLiff() {
    this.setState({ isLiffopen: true });
  }

  setPaymentOptionSelected(option) {
    this.setState({ paymentOptionSelected: option });
  }

  setQuantityToProduct(relatedProducts, addQty = 0) {
    const urlParams = queryString.parse(this.props.location.search);
    const newRelatedProducts = relatedProducts.map((product) => {
      product.quantity = product.id === urlParams?.productId ? addQty : 0;
      if (product.kitEntries.length > 0) {
        product.kitEntries.map((kitEntry) => {
          const configuredQty = kitEntry.configuredQty;
          if (kitEntry.product.baseOptions.length > 0) {
            const baseOptions = kitEntry.product.baseOptions[0];
            let qtyFlag = false;
            baseOptions.options.map((option, index) => {
              if (kitEntry.product.baseProduct) {
                if (baseOptions.selectedId) {
                  const quantity =
                    baseOptions.selectedId === option.id ? configuredQty : 0;
                  option.quantity = quantity;
                  option.lastQuantity = quantity;
                }
              } else {
                let qty = 0;
                if (!qtyFlag && option.stock?.stockLevelStatus !== STOCK_STATUS.outOfStock) {
                  qty = configuredQty;
                  qtyFlag = true;
                }
                option.quantity = qty;
                option.lastQuantity = qty;
              }
            });
          }
        });
      }
      return product;
    });
    return newRelatedProducts;
  }

  setTotalprice(totalPrice) {
    return this.setState({ totalPrice });
  }

  setCartEntries = (entries) => {
    return this.setState({ entries });
  };

  setAccountType = (accountType) => {
    return this.setState({ accountType });
  };

  setTotalPointValue = (totalPointValue) => {
    return this.setState({ totalPointValue });
  };

  setTotalBusinessVolume = (totalBusinessVolume) => {
    return this.setState({ totalBusinessVolume });
  };

  setTotalSelected(totalSelected) {
    return this.setState({ totalSelected });
  }

  setProductSelected(productId, quantity, updateState, rootProductId) {
    const relatedProducts = this.state.relatedProducts.map((product) => {
      if (product.id === productId) {
        product.quantity = quantity;
      }
      if (product.kitEntries.length > 0) {
        product.kitEntries.map((kitEntry) => {
          if (kitEntry.product.baseOptions.length > 0) {
            const baseOptions = kitEntry.product.baseOptions[0];
            baseOptions.options.map((option) => {
              if (kitEntry.kitEntryCode.indexOf(rootProductId) >= 0) {
                if (updateState === UpdateState.FINISH) {
                  option.lastQuantity = option.quantity;
                } else if (option.id === productId) {
                  if (updateState === UpdateState.CLEAR) {
                    option.quantity = option.lastQuantity;
                  }
                  if (updateState === UpdateState.CHANGE) {
                    option.quantity = quantity;
                  }
                }
              }
            });
          }
        });
      }
      return product;
    });
    this.setState({ relatedProducts });
  }

  async handleProductToCart() {
    if (this.state.totalPrice === 0) {
      return;
    }

    const isHavePayByInstallment =
      this.state.promotionData.paymentOptions.length !== 0;
    if (isHavePayByInstallment) {
      this.handleFilterPaymentOptions();
      return;
    }

    this.handleFullPayment();
  }

  handleFilterPaymentOptions() {
    const selectedProducts = this.state.relatedProducts.filter(
      (product) => product.quantity !== 0,
    );
    let allPaymentMethods = [];

    for (const product of selectedProducts) {
      if (product.paymentOptions.length) {
        const paymentOptions = [...this.state.promotionData.paymentOptions, ...product.paymentOptions]
        allPaymentMethods = Object.values(paymentOptions.reduce((acc, item) => {
          item.title = item?.paymentType?.key?.toUpperCase() === PAYMENT_OPTION.PIF ? PAYMENT_TYPE.PIF : PAYMENT_TYPE.ZIPP;
          const key = item?.paymentType?.key?.toUpperCase().includes(PAYMENT_OPTION.PIF) ? PAYMENT_OPTION.PIF : PAYMENT_OPTION.ZIPP;
          acc[key] = item;
          return acc;
        }, {})
        );
      }
    }

    this.setState({ paymentOptions: allPaymentMethods.reverse() });
    this.onOpenLiff();
    return;
  }

  async handleFullPayment() {
    this.setState({ loading: true });
    const cartId = sessionStorage.getItem(SESSION_KEY.pifCartId);
    const customerFOA = JSON.parse(sessionStorage.getItem('customerFOAData'));

    const response = !customerFOA
      ? await addProductsToCart(cartId, this.state.relatedProducts)
      : await addProductsToCartPublic(
        cartId,
        this.state.relatedProducts,
        this.state.cart[0].guid,
      );

    sessionStorage.setItem('guid', this.state.cart[0].guid);
    this.setState({ loading: false });

    if (response.error) {
      return CustomSweetAlert({
        title: "",
        text: response.error[0].th_message,
        confirmButtonText: "ตกลง",
      });
    }
    //Update latest cartData to redux
    await this.props.updateCartData([response.data]);
    this.goToCart();
  }

  async handlePayByInstallment() {
    try {
      this.setState({ loading: true, isLiffopen: false });
      if (
        this.state.paymentOptionSelected.paymentType.key === PAYMENT_OPTION.PIF
      ) {
        await this.handleFullPayment();
        return;
      }
      const { userId } = await liffGetProfile();
      let cart = null;
      if (!sessionStorage.getItem(SESSION_KEY.zippCartId)) {
        cart = await createCartInstallment(userId);
      }
      const cartId = cart?.id ?? sessionStorage.getItem(SESSION_KEY.zippCartId);
      const response = await addProductsInstallmentToCart(
        cartId,
        this.state.relatedProducts,
        this.state.paymentOptionSelected,
      );
      if (response.error) {
        CustomSweetAlert({
          title: "",
          text: response.error[0].th_message,
          confirmButtonText: "ตกลง",
        });
        this.setState({ loading: false });
        return;
      }
      //Update latest cartData to redux
      await this.props.updateCartData([response.data]);
      this.setState({ loading: false });
      const encodedCartID = cartId && cartId.includes('#') ? encodeURIComponent(cartId) : cartId
      sessionStorage.setItem(SESSION_KEY.zippCartId, encodedCartID);
      this.props.history.push(`${commonConstant.pathCartPromotion}?isInstallment=TRUE`);
    } catch (error) {
      CustomSweetAlert({
        title: "",
        text: message.error.somethingWrong,
        confirmButtonText: "ตกลง",
      });
      this.setState({ loading: false });
    }
  }

  goToCart() {
    const urlParams = new URLSearchParams(this.props.location.search);
    urlParams.set(SESSION_KEY.isInstallment, INSTALLMENT_TYPE.FALSE);
    this.props.history.push({ pathname: commonConstant.pathCartPromotion, search: urlParams.toString() });
  }

  renderProduct(relatedProducts) {
    if (relatedProducts.length === 0) {
      return <></>;
    }
    return relatedProducts.map((product, index) => {
      const img =
        product.galleryImages.length > 0
          ? product.galleryImages[0].image_url
          : '';
      let customerFOA = sessionStorage.getItem('customerFOAData');
      let aboPrice = product.prices.find((value) => value.type === ABO_MEMBER);
      let foaPrice = product.prices.find((value) => value.type === FOA_MEMBER);
      foaPrice = +foaPrice?.price;
      aboPrice = +aboPrice?.price;

      const { accountType = '' } = this.state.cart && this.state.cart.length && this.state.cart[0].account
        ? this.state.cart[0].account
        : {};
      const isABOMemberType = isCartABOMemberType(accountType);
      const isABOType = isCartABOType(accountType);
      const isBundletItem = product.kitEntries.length > 0;
      const price = isABOMemberType ? aboPrice : foaPrice;

      if (isBundletItem) {
        const props = {
          img: img,
          key: index,
          id: product.id,
          price,
          code: product.sku,
          stock: product.stock,
          title: product.identifier,
          quantity: product.quantity,
          amwayValue: isABOType ? product.amwayValue : null,
          kitEntries: product.kitEntries,
          totalPrice: this.state.totalPrice,
          setTotalPrice: this.setTotalprice,
          totalPointValue: this.state.totalPointValue,
          setTotalPointValue: this.setTotalPointValue,
          totalBusinessVolume: this.state.totalBusinessVolume,
          setTotalBusinessVolume: this.setTotalBusinessVolume,
          productItemType: ProductItemType.SELECT,
          totalSelected: this.state.totalSelected,
          setTotalSelected: this.setTotalSelected,
          setProductSelected: this.setProductSelected,
        };
        return <BundleProductItem {...props} />;
      }

      const props = {
        img: img,
        key: index,
        id: product.id,
        price,
        code: product.sku,
        stock: product.stock,
        title: product.identifier,
        amwayValue: isABOType ? product.amwayValue : null,
        totalPrice: this.state.totalPrice,
        setTotalPrice: this.setTotalprice,
        totalPointValue: this.state.totalPointValue,
        setTotalPointValue: this.setTotalPointValue,
        totalBusinessVolume: this.state.totalBusinessVolume,
        setTotalBusinessVolume: this.setTotalBusinessVolume,
        totalSelected: this.state.totalSelected,
        productItemType: ProductItemType.SELECT,
        setTotalSelected: this.setTotalSelected,
        setProductSelected: this.setProductSelected,
        isFlashSale: this.state.promotionData.isFlashSale,
        total: product.quantity
      };
      return <Product {...props} />;
    });
  }

  handleDisplayPromotion(promotionData) {
    return this.renderProduct(promotionData);
  }

  handleBackClick() {
    this.props.history.push({ pathname: commonConstant.pathLineOrdering, search: this.props.location.search });
  }

  handleProductDetailsClick() {
    this.props.history.push({ pathname: commonConstant.pathPromotionDetail, search: this.props.location.search });
  }

  renderHeader() {
    const promotion = this.state.promotionData;
    const isCartABOMember = isCartABOMemberType(this.state.accountType);
    //this is the only key for getting must have items
    const isMustHavePromotion =
      isCartABOMember &&
      promotion &&
      promotion.name &&
      promotion.name.toLowerCase() === 'must have items';
    const isRecommenderProductPrm =
      !isCartABOMember && promotion && promotion.name ? true : false;
    const blueHeaderSrc = '/images/sop/sop_profile_list_header.png';
    const orangeHeaderSrc = '/images/bg-header-promotion.png';
    const imgSrc =
      isMustHavePromotion || isRecommenderProductPrm
        ? blueHeaderSrc
        : orangeHeaderSrc;
    return (
      <>
        <img src={imgSrc} className="w-100" />
      </>
    );
  }

  render() {
    const { isFOAEmpty, loading } = this.state;
    const disabledStyle = this.state.totalPrice === 0 ? 'disabled' : '';
    return (
      <section className='promotion-product'>
        <LoadingOverlay
          text="Loading"
          spinner
          active={loading}
          styles={{ wrapper: { width: '100%', minHeight: '100%' } }}
        />
        <div className="promotion-container scroll">
          <div className="promotion-header-container">
            <div className="promotion-header flex">
              <div className='back-icon-circle' onClick={this.handleBackClick}>
                <img src='/images/challenge/arrow-black.svg' />
              </div>
              <div className="promotion-content">
                <div className="promotion-title">{'สินค้าในโปรโมชัน'}</div>
              </div>
              {loading ? <p>Loading...</p> : <CartIcon isFOAEmpty={isFOAEmpty} />}
            </div>
            {isCartABOMemberType(this.state.accountType) &&
              <div className="description-box-container">
                {this.state.promotionData?.shortDescription && (
                  <div className="short-description-box">
                    {this.state.promotionData.shortDescription}
                  </div>
                )}
                <div className="promotion-detail-link" onClick={this.handleProductDetailsClick}>
                  {VIEW_MORE_DETAILS}
                </div>
              </div>
            }
          </div>
          <div className="promotion-product-panel">
            <div className="mb-10">
              {this.handleDisplayPromotion(this.state.relatedProducts)}
            </div>
          </div>
        </div>
        <footer>
          <div className="product-panel-footer">
            <div className="select-product-footer font-larger">
              <div className="price-pvbv-container">
                <div className="product-panel-footer-price">
                  <span>฿ {getPriceFormat(this.state.totalPrice)}</span>
                </div>
                {isCartABOType(this.state.accountType) && (
                  <div className="pvbv-total">
                    PV {this.state.totalPointValue.toLocaleString()} / BV{' '}
                    {this.state.totalBusinessVolume.toLocaleString()}
                  </div>
                )}
              </div>
              {this.state.totalPrice == 0 ? (
                <span className="add-to-cart-disabled" disabled>
                  <img
                    src="/images/promotion/icon_cart.svg"
                    style={{ marginRight: '5px' }}
                  />
                  <span className="add-to-cart-text-disabled">ใส่ตะกร้า</span>
                </span>
              ) : (
                <span
                  className="add-to-cart-active"
                  onClick={this.handleProductToCart}
                >
                  <img
                    src="/images/promotion/icon_cart_active.svg"
                    style={{ paddingRight: '6px', paddingBottom: '4px' }}
                  />
                  <span className="add-to-cart-text-active">
                    ใส่ตะกร้า
                  </span>
                </span>
              )}
            </div>
          </div>
        </footer>
        <Liff
          title="เลือกวิธีการชำระที่ต้องการ"
          onClose={this.onCloseLiff}
          isOpen={this.state.isLiffopen}
        >
          <div className="border-panel"          >
            <PaymentOption
              paymentOptions={this.state.paymentOptions}
              setPaymentOptionSelected={this.setPaymentOptionSelected}
            />
          </div>
          <button
            className="btn-bottom"
            onClick={this.handlePayByInstallment}
            disabled={!this.state.paymentOptionSelected}
          >
            ตกลง
          </button>
        </Liff>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.cartApi.data,
    loading: state.cartApi.loading,
    error: state.cartApi.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCartData: (fields, cartId) => dispatch(getCartData(fields, cartId)),
    updateCartData: (data) => dispatch(updateCartData(data)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionProduct);
